import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolClassesPronunciation = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t(
              'service.school.effectiveClasses.explanations.title.learnIntonation',
            )}
          </h2>
          <p className="school-section-description">
            {t(
              'service.school.effectiveClasses.explanations.detail.learnIntonation',
            )}
          </p>
        </div>
        <div className="order-first md:order-last col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            width={250}
            height={200}
            className="flex-image"
            src="/images/intonation.png"
            alt="Intonation Image"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolClassesPronunciation;
